// oAuthConfigs.js
'use strict';
import { AuthId } from '../resource/loginRegisterConstants.js';

const oAuthConfigs = {
  [AuthId.FACEBOOK]: {
    id: AuthId.FACEBOOK,
    url: '/verify/facebook',
    window: {
      title: 'Facebook Login - SWAG',
      argument: 'width=640,height=568,status',
    },
  },
  [AuthId.TWITTER]: {
    id: AuthId.TWITTER,
    url: '/verify/twitter',
    window: {
      title: 'Twitter Login - SWAG',
      argument: 'width=320,height=568,status',
    },
  },
  [AuthId.GOOGLE]: {
    id: AuthId.GOOGLE,
    url: '/verify/google-oauth2',
    window: {
      title: 'Google Login - SWAG',
      argument: 'width=320,height=568,status',
    },
  },
  [AuthId.APPLE_ID]: {
    id: AuthId.APPLE_ID,
    url: '/verify/apple-id?client_id=com.swag.live',
    window: {
      title: ' Sign in with Apple - SWAG',
      argument: 'width=350,height=568,status',
    },
  },
  [AuthId.APPLE_ID_NEW]: {
    id: AuthId.APPLE_ID_NEW,
    url: `/verify/${AuthId.APPLE_ID_NEW}?client_id=com.swag.live.signin`,
    window: {
      title: ' Sign in with Apple - SWAG',
      argument: 'width=350,height=600,status',
    },
  },
  [AuthId.DISCORD]: {
    id: AuthId.DISCORD,
    url: '/verify/discord',
    window: {
      title: 'Discord Login - SWAG',
      argument: 'width=320,height=640,status',
    },
  },
};

export default oAuthConfigs;
